module.exports = __webpack_public_path__ + "static-portal/img/17.1044c52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/17.jpg
// module id = uOFq
// module chunks = 4